import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";

const DatabaseDetail = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    axios.get("/db-info").then(r => setInfo(r.data)).catch(() => {});
  }, []);

  const rows = info ? [
    { label: "Server",    value: info.server },
    { label: "Database",  value: info.database },
    { label: "Port",      value: info.port },
    { label: "SQL Version", value: info.sqlVersion },
    { label: "DB Size",   value: info.dbSize },
    { label: "Status",    value: info.status },
  ] : [];

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Database Detail</span>
        </div>
        <div className="card-body">
          {!info
            ? <p className="text-muted">Loading database information...</p>
            : (
              <table className="table table-bordered table-sm" style={{ fontSize: "13px", maxWidth: "500px" }}>
                <tbody>
                  {rows.map(r => (
                    <tr key={r.label}>
                      <td className="fw-semibold" style={{ width: "160px" }}>{r.label}</td>
                      <td>{r.value || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
      </div>
    </div>
  );
};

export default DatabaseDetail;
